/* eslint-disable no-undef */
import axios from '../services/index';
const UPLOADURL = `${API_BASE_URL}/core/video/getUploadAuth`;
class AliyunUploads {
    constructor (params) {
        this.timeout = '';
        this.partSize = '';
        this.parallel = '';
        this.retryCount = '';
        this.retryDuration = '';
        this.region = 'cn-shanghai';
        this.userId = ALYUN_USERID; // '1407098215866149';
        this.file = null;
        this.authProgress = 0;
        this.uploadDisabled = true;
        this.resumeDisabled = true;
        this.pauseDisabled = true;
        this.uploader = null;
        this.statusText = '';
        this.events = params ? params.events || {} : {};
    }
    
    init () {
        if (this.uploader) {
            this.uploader.stopUpload();
            this.authProgress = 0;
            this.statusText = '';
        }
        this.uploader = this.createUploader();
    }
    addBlobFile (blob, filename, title) {
        if (blob) {
            const file = new File([blob], filename);
            this.fileName = filename;
            this.fileTitle = title;
            const userData = '{"Vod":{}}';
            this.uploader.addFile(file, null, null, null, userData);
            this.uploadDisabled = false;
            this.pauseDisabled = true;
            this.resumeDisabled = true;
        }
    }

    authUpload () {
        // 然后调用 startUpload 方法, 开始上传
        if (this.uploader !== null) {
            this.uploader.startUpload();
            this.uploadDisabled = true;
            this.pauseDisabled = false;
        }
    }

    // 暂停上传
    pauseUpload () {
        if (this.uploader !== null) {
            this.uploader.stopUpload();
            this.resumeDisabled = false;
            this.pauseDisabled = true;
        }
    }
    // 恢复上传
    resumeUpload () {
        if (this.uploader !== null) {
            this.uploader.startUpload();
            this.resumeDisabled = true;
            this.pauseDisabled = false;
        }
    }

    // 重置上传
    resetUpload () {
        if (this.uploader) {
            this.uploader.stopUpload();
            this.authProgress = 0;
            this.statusText = '';
        }
    }

    eventsCall (key, ...params) {
        // eslint-disable-next-line no-unused-expressions
        this.events[key] && this.events[key].call(null, ...params);
    }

    createUploader () {
        const self = this;
        // 保存 uploadAddress，用于后续构建视频 URL
        let currentUploadAddress = null;
        // eslint-disable-next-line no-undef
        const uploader = new AliyunUpload.Vod({
            timeout: self.timeout || 60000,
            partSize: self.partSize || 1048576,
            parallel: self.parallel || 5,
            retryCount: self.retryCount || 3,
            retryDuration: self.retryDuration || 2,
            region: self.region,
            userId: self.userId,
            // 添加文件成功
            addFileSuccess: function (uploadInfo) {
                self.uploadDisabled = false;
                self.resumeDisabled = false;
                self.statusText = '添加文件成功, 等待上传...';
                self.eventsCall('addFileSuccess', uploadInfo);
                self.authUpload();
            },
            // 开始上传
            onUploadstarted: function (uploadInfo) {
                // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
                // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
                // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
                // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
                // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
                // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
                // eslint-disable-next-line no-negated-condition
                let params = {};
                if (uploadInfo.videoId) {
                    params = {
                        fileName: self.fileName,
                        title: self.fileTitle,
                        videoId: uploadInfo.videoId
                    };
                } else {
                    // 如果videoId有值，根据videoId刷新上传凭证
                    // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
                    params = {
                        fileName: self.fileName,
                        title: self.fileTitle
                    };
                    self.statusText = '文件开始上传...';
                }
                axios.get(UPLOADURL, {params, handleErrorBySelf: true}).then(({data}) => {
                    data = data.data;
                    const uploadAuth = data.uploadAuth;
                    const uploadAddress = data.uploadAddress;
                    const videoId = data.videoId;
                    // 保存 uploadAddress，用于后续构建视频 URL
                    currentUploadAddress = uploadAddress;
                    uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
                })
                    .catch(error => {
                        // eslint-disable-next-line no-console
                        self.eventsCall('onUploadFailed', uploadInfo, error && error.name, error && error.message);
                    });
            },
            // 文件上传成功
            onUploadSucceed: function (uploadInfo) {
                self.statusText = '文件上传成功!';
                // 将 uploadAddress 添加到 uploadInfo 中
                const uploadInfoWithAddress = {
                    ...uploadInfo,
                    uploadAddress: currentUploadAddress
                };
                self.eventsCall('onUploadSucceed', uploadInfoWithAddress);
            },
            // 文件上传失败
            onUploadFailed: function (uploadInfo, code, message) {
                self.statusText = '文件上传失败!';
                self.eventsCall('onUploadFailed', uploadInfo, code, message);
            },
            // 取消文件上传
            onUploadCanceled: function (uploadInfo, code, message) {
                self.statusText = '文件已暂停上传';
                self.eventsCall('onUploadCanceled', uploadInfo, code, message);
            },
            // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
            onUploadProgress: function (uploadInfo, totalSize, progress) {
                const progressPercent = Math.ceil(progress * 100);
                self.authProgress = progressPercent;
                self.statusText = '文件上传中...';
                self.eventsCall('onUploadProgress', uploadInfo, totalSize, progress);
            },
            // 上传凭证超时
            onUploadTokenExpired: function (uploadInfo) {
                // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
                // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
                // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
                const params = {
                    fileName: self.fileName,
                    title: self.fileTitle,
                    videoId: uploadInfo.videoId
                };

                axios.get(UPLOADURL, {params, handleErrorBySelf: true}).then(({data}) => {
                    data = data.data;
                    const uploadAuth = data.uploadAuth;
                    uploader.resumeUploadWithAuth(uploadAuth);
                })
                    .catch(error => {
                        // eslint-disable-next-line no-console
                        self.eventsCall('onUploadFailed', uploadInfo, error && error.name, error && error.message);
                    });
                self.statusText = '文件超时，尝试重连...';
            },
            // 全部文件上传结束
            onUploadEnd: function (uploadInfo) {
                self.statusText = '文件上传完毕';
                self.eventsCall('onUploadEnd', uploadInfo);
            }
        });
        return uploader;
    }

}
export default AliyunUploads;
